<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ feedbackDetails.student.firstName }}
          {{ feedbackDetails.student.lastName }}
        </h3>
        <button
          nz-button
          type="button"
          nz-button
          nzType="primary"
          (click)="submitFeedback()"
          aria-label="Submit feedback for student">
          Submit Feedback
        </button>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"></svg-icon>
            {{ feedbackDetails.student.dateOfBirth | date: 'MM/dd/yyyy' }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"></svg-icon>
            {{ feedbackDetails.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-18"></svg-icon>
            {{ feedbackDetails.student.gender }}
          </p>
        </div>
      </div>
    </div>
    <nz-divider />
    <!-- Feedback History Table -->
    <nz-table
      #sortTable
      nzShowSizeChanger
      [nzData]="(feedBackHistory$ | async)?.result?.items ?? []"
      [nzFrontPagination]="false"
      [nzTotal]="(feedBackHistory$ | async)?.result?.totalRows || 0"
      [(nzPageIndex)]="pageIndex"
      [nzPageSize]="pageSize"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzScroll]="{ x: '1200', y: 'calc(100vh - 354px)' }">
      <thead>
        <tr>
          <th
            nzWidth="400px"
            [nzSortFn]="true"
            [title]="listOfColumn[0].title"
            [nzColumnKey]="listOfColumn[0].key">
            {{ listOfColumn[0].title }}
          </th>
          <th
            nzWidth="250px"
            [nzSortFn]="true"
            [title]="listOfColumn[1].title"
            [nzColumnKey]="listOfColumn[1].key">
            {{ listOfColumn[1].title }}
          </th>
          <th
            nzWidth="150px"
            [nzSortFn]="true"
            [title]="listOfColumn[2].title"
            [nzColumnKey]="listOfColumn[2].key">
            {{ listOfColumn[2].title }}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of sortTable.data">
          <td>
            {{ item.caseMemberUserFirstName }} {{ item.caseMemberUserLastName }}
          </td>
          <td>{{ item.createdDate | userDate: 'MM/dd/yyyy hh:mm a' }}</td>
          <td>
            {{ item.isAllQuestionsFeedbackSubmitted ? item.overallScore : '-' }}
          </td>
          <td>
            <div class="action-btn-wrapper">
              <button
                *ngIf="
                  !item.isAllQuestionsFeedbackSubmitted &&
                  loggedInUserId === item.caseMemberUserId
                "
                type="button"
                nz-button
                nzType="default"
                class="primary-outlined"
                (click)="viewFeedback(item, insightMode.RESUME)">
                Resume
              </button>
              <button
                *ngIf="
                  item.isAllQuestionsFeedbackSubmitted &&
                  isFeedBackEditable &&
                  loggedInUserId === item.caseMemberUserId
                "
                type="button"
                nz-button
                nzType="default"
                class="primary-outlined"
                (click)="viewFeedback(item, insightMode.EDIT)">
                Edit
              </button>
              <button
                *ngIf="item.isAllQuestionsFeedbackSubmitted"
                type="button"
                nz-button
                nzType="default"
                class="primary-outlined"
                (click)="viewFeedback(item)">
                View
              </button>
              <!--Keep this button commented till next Release as this is not part of this milestone-->
              <button
                *ngIf="item.isAllQuestionsFeedbackSubmitted"
                type="button"
                [nzLoading]="isPrintLoadingForItem(item.id) | async"
                nz-button
                nzType="default"
                class="primary-outlined"
                (click)="showAdminNote(item)">
                Print
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #viewFeedbackFormTpl>
      <app-drawer-header
        [title]="'Feedback'"
        subtitle="Feedback"
        [breadcrumbText]="feedbackDetails.student.firstName || ''"
        (close)="closeFeedBackFormDrawer()">
      </app-drawer-header>
    </ng-template>
  </div>
</nz-spin>
<nz-modal
  [(nzVisible)]="isModalVisible"
  [nzTitle]="modalHeaderTemplate"
  (nzOnCancel)="handleModalClose()"
  nzWidth="1000px"
  [nzClassName]="'small-header-height'">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <h3 class="ant-modal-title">Admin Note</h3>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <form nz-form class="form" [formGroup]="printForm">
      <div class="drawer-form-wrapper feedback-print-modal">
        <app-graph-filter
          (filterChange)="onFilterChange($event)"></app-graph-filter>
        <nz-form-control class="mt-16">
          <textarea
            id="adminNote"
            name="adminNote"
            nz-input
            rows="4"
            placeholder="Enter admin note"
            formControlName="adminNote">
          </textarea>
        </nz-form-control>
      </div>
    </form>
  </ng-container>

  <div *nzModalFooter>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleModalClose()">
        Close
      </button>
      <button
        nz-button
        nzType="primary"
        [disabled]="
          printForm.invalid ||
          (isPrintLoadingForItem(selectedFeedback?.id || 0) | async)
        "
        [nzLoading]="isPrintLoadingForItem(selectedFeedback?.id || 0) | async"
        (click)="printFeedback()">
        Print
      </button>
    </div>
  </div>
</nz-modal>
